import { useMemo } from 'react'
import useYesObject from 'yesObject/shared/hooks/useYesObject'
import { UseClassifiedChartsProps } from '../Cockpit.types'
import { Classification, classifyCharts } from '../utils/classifyChartElements'

const useClassifiedCharts = ({
  charts,
  classificationUuid,
  filterEmptyCharts = false
}: UseClassifiedChartsProps) => {
  const { yesObject: classificationObject, isLoading } = useYesObject({
    objectUUID: classificationUuid,
    objectclassUUID: globalThis.classificationObjectclassUuid,
    skipRelations: false
  })

  const classificationContent =
    classificationObject?.classification_content as string

  const parsedContent = useMemo(() => {
    if (!classificationContent) {
      return []
    }

    try {
      return JSON.parse(classificationContent) as Classification[]
    } catch (error) {
      console.error('Error parsing classification content:', error)
      return []
    }
  }, [classificationContent])

  const { classifiedCharts, sectionsUuids } = useMemo(() => {
    const returnedCharts = classificationContent
      ? classifyCharts(charts, parsedContent)
      : [charts]

    const allSectionsUuids = parsedContent.map(
      (content) => content?.uuid_object || ''
    )

    if (filterEmptyCharts && returnedCharts.length > 0) {
      const kept = returnedCharts
        .map((row, index) => ({
          row,
          sectionUuid: allSectionsUuids[index] ?? ''
        }))
        .filter(({ row }) => row.some((cell) => cell != null))

      return {
        classifiedCharts: kept.map(({ row }) => row),
        sectionsUuids: kept.map(({ sectionUuid }) => sectionUuid)
      }
    }

    return {
      classifiedCharts: returnedCharts,
      sectionsUuids: allSectionsUuids
    }
  }, [classificationContent, charts, parsedContent, filterEmptyCharts])

  if (!charts)
    return {
      isLoading,
      sectionsUuids: [],
      classifiedCharts: [[]]
    }

  return {
    isLoading,
    classifiedCharts,
    sectionsUuids
  }
}

export default useClassifiedCharts
